export const onlyNum = (e) => {
  if (!e) return false;
  const keyCode = e.keyCode;
  if (!(48 <= keyCode && keyCode <= 57) || keyCode === 8) {
    e.preventDefault();
  }
}

export const makeHasError = form => (key) => {
  return form.values[key] && form.touched[key] && form.errors[key];
};

export const makeValidClasses = form => (fieldName, subCondtion = true) => {
  if (!form.values[fieldName]) return "";
  if (form.touched[fieldName] && form.errors[fieldName]) {
    return "is-invalid";
  }
  if (form.touched[fieldName] && !form.errors[fieldName] && subCondtion) {
    return "is-valid";
  }
  return "";
};
